export default [
  {
    title: "Self Help tool 1",
    Images: "1",
    Attachments: "1",
  },
  {
    title: "Self Help tool 1",
    Images: "1",
    Attachments: "1",
  },
  {
    title: "Self Help tool 1",
    Images: "1",
    Attachments: "1",
  },
];
